export default {
  containerStyles: {
    display: "flex",
    flexDirection: "row" as "row",
  },

  textStyles: {
    fontFamily: "Roboto",
    padding: "0.5rem",
    margin: "0.5rem 0 0 0",
  },
};
